import { Component, OnChanges, Input } from "@angular/core";

import { ApiService, } from "src/app/api.service";
import { APIResults, } from "src/app/sharedinterfaces";
import { ChartingService } from "src/app/charting.service";

@Component({
	selector: "app-fdm",
	templateUrl: "./fdm.component.html",
	styleUrls: ["./fdm.component.scss"]
})
export class FdmComponent implements OnChanges {
	@Input()
	asset: APIResults.FleetAsset;
	@Input()
	fleet: APIResults.Fleet;
	@Input()
	components: APIResults.AssetComponentList;

	public onlyExceedances = false;
	public showEmpty = false;
	public operations: APIResults.Operation[] = [];
	public selectedOperation;

	constructor(public api: ApiService, private charting: ChartingService) { }

	async ngOnChanges() {
		await this.updateOperations();
	}

	async updateOperations() {
		const operations = await this.api.GetOperations(this.asset.asset_id, 800, this.showEmpty, this.onlyExceedances);
		this.operations = operations;
		if (this.operations.length > 0) {
			this.selectedOperation = this.operations[0];
		}
	}
}
